import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { DescriptionItemCategory, DescriptionIgnoredItem, DescriptionItem, Description } from "../model/description.model";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { takeUntil } from "rxjs/operators";
import { Item } from "../model/item.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";

@Component({
  selector: "ngx-description-form",
  templateUrl: "./description-form.component.html",
  styleUrls: ["./description-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DescriptionFormComponent extends BaseFormComponent<Description> {
  Categories: number[] = [];
  Items: number[] = [];
  IgnoredItems: number[] = [];
  ItemWithCategory: Item[] = [];
  IgnoredItemsWithCategory: Item[] = [];
  erroremessage: string;
  deactivateSave: boolean = false;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.FillData();
  }

  async ngOnInit() {
    this.apiName = "Description";
    this.label = this.translate("ClientApp.FrontOffice.Catalog.Description.Description");
    super.ngOnInit();
  }

  setdefault() {
    if (!this.model.IgnoredItems) this.model.IgnoredItems = [];
    if (!this.model.Items) this.model.Items = [];
    if (!this.model.Categories) this.model.Categories = [];

    this.model.Categories.forEach((x) => {
      if (!this.Categories.some((d) => d === x.CategoryId)) this.Categories.push(x.CategoryId);
    });
    this.model.IgnoredItems.forEach((x) => {
      if (!this.IgnoredItems.some((d) => d === x.ItemId)) this.IgnoredItems.push(x.ItemId);
    });
    this.model.Items.forEach((x) => {
      if (!this.Items.some((d) => d === x.ItemId)) this.Items.push(x.ItemId);
    });
    if (this.model.BranchId == undefined) this.model.BranchId = this.accountService.authService.currentBranchId;
    this.valueChange();
  }

  addControl() {
    if (this.formGroup) {
      this.setValue("IgnoredItems", this.IgnoredItems);
      this.setValue("Items", this.Items);
      this.setValue("Categories", this.Categories);
    }
    this.cd.markForCheck();
  }

  valueChange() {
    if (this.formGroup) {
      this.Categories = this.formGroup.controls["Categories"].value;
      this.Items = this.formGroup.controls["Items"].value;
      this.IgnoredItems = this.formGroup.controls["IgnoredItems"].value;
    }

    this.httpCommonService
      .createlist("Item/GetItemWithCategory", this.Categories)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: Item[]) => {
        this.ItemWithCategory = x;
        this.selectorService.setDataList("Items", this.ItemWithCategory);
        var list: number[] = [];
        this.Items.forEach((x) => {
          if (this.ItemWithCategory.some((i) => i.Id === x)) {
            list.push(x);
          }
        });
        this.Items = list;
        this.setValue("Items", this.Items);
        // this.formGroup.controls['Items'].setValue(this.Items);
      });

    this.httpCommonService
      .createlist("Item/GetIgnoredItem", this.Categories)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: Item[]) => {
        this.IgnoredItemsWithCategory = x;
        this.selectorService.setDataList("IgnoredItems", this.IgnoredItemsWithCategory);
        let list: number[] = [];
        this.IgnoredItems.forEach((x) => {
          if (this.IgnoredItemsWithCategory.some((i) => i.Id === x)) {
            list.push(x);
          }
        });
        this.IgnoredItems = list;
        this.formGroup.controls["IgnoredItems"].setValue(this.IgnoredItems);
      });
  }

  beforupdate() {
    this.Categories = this.formGroup.value.Categories;
    this.model.Categories.forEach((x) => {
      if (!this.Categories.some((r) => r === x.CategoryId)) x.State = RowState.Delete;
    });
    this.Categories.forEach((x) => {
      if (!this.model.Categories.some((r) => r.CategoryId === x)) {
        var category: DescriptionItemCategory = <DescriptionItemCategory>{};
        category.CategoryId = x;
        category.DescriptionId = this.model.Id;
        category.State = RowState.New;
        this.model.Categories.push(category);
      }
    });
    this.formGroup.controls["Categories"].setValue(this.model.Categories);

    this.IgnoredItems = this.formGroup.value.IgnoredItems;
    this.model.IgnoredItems.forEach((x) => {
      if (!this.IgnoredItems.some((r) => r === x.ItemId)) x.State = RowState.Delete;
    });
    this.IgnoredItems.forEach((x) => {
      if (!this.model.IgnoredItems.some((r) => r.ItemId === x)) {
        var ignoredItem: DescriptionIgnoredItem = <DescriptionIgnoredItem>{};
        ignoredItem.ItemId = x;
        ignoredItem.DescriptionId = this.model.Id;
        ignoredItem.State = RowState.New;
        this.model.IgnoredItems.push(ignoredItem);
      }
    });
    this.formGroup.controls["IgnoredItems"].setValue(this.model.IgnoredItems);

    this.Items = this.formGroup.value.Items;
    this.model.Items.forEach((x) => {
      if (!this.Items.some((r) => r === x.ItemId)) x.State = RowState.Delete;
    });
    this.Items.forEach((x) => {
      if (!this.model.Items.some((r) => r.ItemId === x)) {
        var item: DescriptionItem = <DescriptionItem>{};
        item.ItemId = x;
        item.DescriptionId = this.model.Id;
        item.State = RowState.New;
        this.model.Items.push(item);
      }
    });
    this.formGroup.controls["Items"].setValue(this.model.Items);
  }

  // چک کردن انتقال اطلاعات مدیریت شعب
  async FillData() {
    if (
      this.accountService.authService.currentInformation().BranchingLightEnabled ||
      this.accountService.authService.currentInformation().BranchingAdvancedEnabled
    ) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/Description")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Catalog.Description.HasBranchCommunication"),
                this.translate("ClientApp.FrontOffice.Catalog.Description.Attention")
              );
              this.deactivateSave = true;
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.sts.showDialog(
                  this.translate("ClientApp.FrontOffice.Catalog.Description.HasCallCenterCommunication"),
                  this.translate("ClientApp.FrontOffice.Catalog.Description.Attention")
                );
                this.deactivateSave = true;
                return;
              }
            }
          }
        });
      (error) => this.getFailedHelper(error);
    }
  }
}
